<template>
  <div class="pdl-detail-information mt-5" v-if="pdl">

    <v-row>
      <v-col md="8">

        <v-row>
          <v-col class="label" sm="3">{{ $t('name') }} :</v-col>
          <v-col sm="9">
            {{ pdl.name }}
            <v-chip v-if="pdl.isDefault" x-small class="ml-2">{{ $t('pdl.default') }}</v-chip>
            <v-btn small class="ml-3" v-if="canWrite" :to="{name: 'pdl.edit'}">
              <v-icon small left>mdi-pencil</v-icon>
              {{ $t('edit') }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="label" sm="3">{{ $t('pdl.reference') }} :</v-col>
          <v-col sm="9">
            <template v-if="pdl.reference">{{ pdl.reference }}</template>
            <span v-else class="text--secondary">{{ $t('pdl.reference-missing') }}</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="label" sm="3">{{ $t('pdl.bills') }} :</v-col>
          <v-col sm="9">
            {{ pdl.billsOperator ? $t('pdl.bills-operator') : $t('pdl.bills-location-organization') }}
          </v-col>
        </v-row>

        <v-row>
          <v-col class="label" sm="3">{{ $t('organization.organization') }} :</v-col>
          <v-col sm="9">
            <router-link :to="{name: 'organizations.detail', params: {id: pdl.organizationId}}">
              {{ pdl.organizationName }}
            </router-link>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="label" sm="3">{{ $t('price-component.energy-price') }} :</v-col>
          <v-col sm="9">
            <pdl-energy-price-module :pdl-id="pdl.id" readonly />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="label" sm="3">{{ $t('created-at') }} :</v-col>
          <v-col sm="9">
            {{ pdl.createdAt|formatDate($t('format_date')) }}
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </div>
</template>

<script>
import PdlEnergyPriceModule from "@blocks/Pdl/PdlEnergyPriceModule.vue";

export default {
  components: {PdlEnergyPriceModule},

  computed: {
    pdl() {
      return this.$parent.pdl ?? null
    },

    canWrite() {
      return this.currentUser.isZE && this.currentUser.permissions.includes('STATION_WRITE')
    },
  },
}
</script>

<style lang="scss" scoped>
.label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
